import { client } from '@global/Api';
import {
  GET_SUGGEST_ADDRESSES,
  GET_SUGGEST_ADDRESSES_TYPE,
} from '@global/requests/addressDoctor/GET_SUGGEST_ADDRESSES';

import { RootState, store } from '@global/store/store';
import { CountryService } from '@global/utils/CountryService';

import { BillingInfoFormValuesType } from '@global/components/BillingInfoForm/types';
import { IBillingInfo } from '@global/types/types';

type SuggestAddressErrorType = {
  code?: string;
  hasQ0Failure?: boolean;
  message?: string;
};

export type SuggestAddressResult = {
  addresses: IBillingInfo[];
  hasQ0Failure: boolean;
  validationMessage: string | null;
};

export async function getSuggestAddresses(
  address: BillingInfoFormValuesType
): Promise<SuggestAddressResult> {
  try {
    const { country } = store.getState() as RootState;

    const { data } = await client.query<GET_SUGGEST_ADDRESSES_TYPE>({
      query: GET_SUGGEST_ADDRESSES,
      variables: {
        address,
      },
    });

    const suggestAddressData = data.wSuggestAddresses;
    const validationErrors: SuggestAddressErrorType[] =
      suggestAddressData?.errors || [];
    const q0Error = validationErrors.find(
      ({ hasQ0Failure, code }) => hasQ0Failure || code === 'VALIDATION_FAILURE'
    );

    const currentAddress = {
      country: CountryService.getCountryByIsoCode(
        country.countries,
        address.country
      ),
      city: address.city,
      addressOne: address.address1,
      addressTwo: address.address2,
      zip: address.zip,
      state: address.state,
    };

    const mappedSuggestAddresses = suggestAddressData.suggestedAddresses.map(
      (item) => {
        const countryObj = CountryService.getCountryByIsoCode(
          country.countries,
          item.COUNTRY_ISO2
        );

        let stateCode = item.REGION_CD;
        if (
          item.COUNTRY_ISO2 === 'CN' &&
          item.REGION_NM &&
          countryObj?.regions
        ) {
          const region = CountryService.getStateByName(
            countryObj.regions,
            item.REGION_NM
          );
          if (region?.isoCodeShort) {
            stateCode = region.isoCodeShort;
          }
        }

        return {
          country: countryObj,
          city: item.CITY,
          addressOne: item.ADDRESS_LINE_1,
          addressTwo: item.ADDRESS_LINE_2,
          zip: item.POSTAL_CODE,
          state: stateCode,
        };
      }
    );

    return {
      addresses: [currentAddress, ...mappedSuggestAddresses],
      hasQ0Failure: Boolean(q0Error),
      validationMessage: q0Error?.message || null,
    };
  } catch (error) {
    console.error(error);

    return {
      addresses: [],
      hasQ0Failure: false,
      validationMessage: null,
    };
  }
}
